import React from "react";

import Dashboard from "./Dashboard";
import DashBoardApp from "./DashBoardApp";
import Profile from "./Profile";
import ProfileApp from "./ProfileApp";

function Profile2({ cat, sliderdate }) {
  function isWebView() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Example for Android WebView (check for "wv")
    if (/wv/.test(userAgent) || /Android.*WebView/.test(userAgent)) {
      return true;
    }

    // Example for iOS WebView (check for "iPhone OS" without "Safari")
    if (/iPhone|iPod|iPad/.test(userAgent) && !/Safari/.test(userAgent)) {
      return true;
    }

    return false; // Assume it's a browser if no WebView signature is detected
  }

  if (isWebView()) {
    console.log("Running inside a WebView");
  } else {
    console.log("Running inside a browser");
  }
  return (
    <div>
      {isWebView() ? (
        <div>
          {/* <HeaderMain /> */}

          <ProfileApp />

          {/* <FooterMain /> */}
        </div>
      ) : (
        <div>
          {/* <HeaderMain /> */}
          <Profile />
          {/* <FooterMain /> */}
        </div>
      )}
    </div>
  );
}

export default Profile2;
